import { mediaGQLFields } from '../media/index.js';
import { memberGQLFields } from '../network/index.js';
import { postGQLFields } from '../post/index.js';
import { spaceGQLFields } from '../space/index.js';
const BASIC_PAYLOAD_FIELDS = {};
const ALL_PAYLOAD_FIELDS = {
    media: 'all',
    member: 'basic',
    post: 'basic',
    space: 'basic',
};
export function payloadGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_PAYLOAD_FIELDS;
    if (fields === 'all')
        fields = ALL_PAYLOAD_FIELDS;
    return `
    id
    name
    summary
    type
    ${fields.media
        ? `
      media {
        ${mediaGQLFields(fields.media)}
      }
    `
        : ``}
    ${fields.member
        ? `
      member {
        ${memberGQLFields(fields.member)}
      }
    `
        : ``}
    ${fields.post
        ? `
      post {
        ${postGQLFields(fields.post)}
      }
    `
        : ``}
    ${fields.space
        ? `
      space {
        ${spaceGQLFields(fields.space)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=payload.fields.js.map